import { combineReducers, configureStore } from "@reduxjs/toolkit";
import authReducer from "../store/slices/auth";
import planReducer from "./slices/plan";
import profileReducer from "./slices/profile";

import bookingReducer from "./slices/booking";
import fundReducer from "./slices/fund"

const rootReducer = combineReducers({
  auth: authReducer,
  plan: planReducer,
  profile: profileReducer,
  booking: bookingReducer,
  fund: fundReducer


});

const store = configureStore({
  reducer: rootReducer,
  devTools: true,
});
export default store;
